export const updateRegion = (payload: string | null) => {
  if (typeof window !== 'undefined') {
    const savedRegion = localStorage.getItem('savedRegion');
    if (savedRegion) {
      if (savedRegion.length > 0) {
        localStorage.removeItem('savedRegion');
        localStorage.setItem('savedRegion', JSON.stringify(payload));
      }
    } else {
      localStorage.setItem('savedRegion', JSON.stringify(payload));
    }
  }
};

export const getRegion = () => {
  if (typeof window !== 'undefined') {
    const savedRegion = localStorage.getItem('savedRegion');
    return savedRegion ? JSON.parse(savedRegion) : '';
  }
};
